import { CloseIcon, ExternalLink, RoleBadge } from '../shared';

function EntryCard({ entry, index }) {
  return (
    <div className="panel-entry">
      <div className="panel-entry-number">Entry {index + 1}</div>

      <div className="panel-entry-grid">
        {entry.skill && (
          <div className="panel-entry-field">
            <span className="panel-field-label">Skill</span>
            <p className="panel-field-value">{entry.skill}</p>
          </div>
        )}
        {entry.attitude && (
          <div className="panel-entry-field">
            <span className="panel-field-label">Attitude</span>
            <p className="panel-field-value">{entry.attitude}</p>
          </div>
        )}
      </div>

      {entry.roles?.length > 0 && (
        <div className="panel-entry-roles">
          <span className="panel-field-label">Roles</span>
          <div className="panel-roles-list">
            {entry.roles.map((role, rIdx) => (
              <RoleBadge key={rIdx} role={role} variant="panel" />
            ))}
          </div>
        </div>
      )}

      {entry.learning && (
        <div className="panel-entry-learning">
          <span className="panel-field-label">Learning Resource</span>
          <div className="panel-learning-card">
            <span className="panel-learning-type">{entry.learning.type}</span>
            <a
              href={entry.learning.url}
              target="_blank"
              rel="noopener noreferrer"
              className="panel-learning-link"
            >
              {entry.learning.title}
              <ExternalLink />
            </a>
            {entry.learning.description && (
              <p className="panel-learning-desc">{entry.learning.description}</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export function ActionDetailPanel({ action, onClose }) {
  if (!action) return null;

  // Calculate unique stats
  const uniqueSkills = [...new Set(action.entries.filter(e => e.skill).map(e => e.skill))];
  const uniqueRoles = [...new Set(action.entries.flatMap(e => e.roles || []))];

  return (
    <div className="action-panel-overlay" onClick={onClose}>
      <div className="action-panel" onClick={(e) => e.stopPropagation()}>
        <div className="action-panel-header">
          <h2>{action.name}</h2>
          <button className="action-panel-close" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>

        <div className="action-panel-content">
          {/* Summary Stats */}
          <div className="panel-summary">
            <div className="panel-stat">
              <span className="panel-stat-value">{action.entryCount}</span>
              <span className="panel-stat-label">Entries</span>
            </div>
            <div className="panel-stat">
              <span className="panel-stat-value">{uniqueSkills.length}</span>
              <span className="panel-stat-label">Skills</span>
            </div>
            <div className="panel-stat">
              <span className="panel-stat-value">{uniqueRoles.length}</span>
              <span className="panel-stat-label">Roles</span>
            </div>
          </div>

          {/* Connected Competencies */}
          {action.competencyNames?.length > 0 && (
            <div className="panel-section">
              <h3 className="panel-section-title">
                Connected Competencies ({action.competencyNames.length})
              </h3>
              <div className="panel-competencies">
                {action.competencyNames.map((name, idx) => (
                  <div key={idx} className="panel-competency-chip">
                    {name}
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Entries List - Grouped by Competency */}
          <div className="panel-section">
            <h3 className="panel-section-title">
              Skills, Attitudes & Learning
            </h3>
            {action.entriesByCompetency ? (
              // Group entries by their source competency
              Object.entries(action.entriesByCompetency).map(([compId, entries]) => (
                <div key={compId} className="panel-competency-group">
                  {action.competencyIdToName && Object.keys(action.entriesByCompetency).length > 1 && (
                    <h4 className="panel-competency-header">
                      From: {action.competencyIdToName[compId]}
                    </h4>
                  )}
                  <div className="panel-entries">
                    {entries.map((entry, idx) => (
                      <EntryCard key={idx} entry={entry} index={idx} />
                    ))}
                  </div>
                </div>
              ))
            ) : (
              // Fallback for flat entries array
              <div className="panel-entries">
                {action.entries.map((entry, idx) => (
                  <EntryCard key={idx} entry={entry} index={idx} />
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
